import { render, staticRenderFns } from "./EmergenyService.vue?vue&type=template&id=30daf1a7&"
import script from "./EmergenyService.vue?vue&type=script&lang=js&"
export * from "./EmergenyService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports